import { useEffect, useMemo, useRef, useState } from 'react';
import { CloseOutlined, ExclamationCircleFilled, LeftOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import _ from 'lodash';
import { watchPageVisibility } from '@/utils';

import {
  ACCESS_TOKEN,
  delCookieToken,
  getCookieToken,
  getLocalZhiyinUser,
  getPageActionTimeCount,
  onCloseLoginModal,
  onShowLoginModal,
  processNoticeData,
  setCookieTokens,
  setLocalZhiyinUser,
  setPageActionTimeCount,
  setTokenApi,
  setTokenFn,
} from '../utils';
import customLocalStorgeEventListener from '../utils/timeout';
import AlertText from './AlertText';
import Login from './FormLogin';
import SetPwd from './FormSetPwd';

import './index.less';

import { history, useLocation } from 'umi';
import { getFontMeApi, magicGetFontMeApi } from '@/services/login';

import { event, showBindPhoneModal } from '../event';
import customCookieEventListener from '../utils/timeoutCooke';

let autoRefreshInterval: any; //  自动token定时器
let pageActionInterval: any; //  自动页面监听定时器

const LoginApp = (props: any) => {
  // 默认是否弹框

  const {} = props;

  const init = () => {
    // 首次判断有没有token
    const token = getCookieToken();
    if (token) {
      initSet(token);
      return false;
    }
    if (history.location.pathname === '/' || history.location.pathname === '/aminerandzhiyin') {
      return false;
    }
    onShowLoginModal();
    return true;
  };
  const [isModalOpen, setIsModalOpen] = useState<boolean>(init);
  const [showOtherClientStatus, setShowOtherClientStatus] = useState(false); // 显示其他设备登录的文字
  const [currentAction, setCurrentAction] = useState('login'); // 当前tab 是登录
  const [showTabRefresh, setShowTabRefresh] = useState(false); // 显示 tab 刷新

  useMemo(() => {
    setCurrentAction('login'); // 重置默认登录tab
    setShowTabRefresh(false);
    if (isModalOpen === false) {
      setShowOtherClientStatus(false);
    }
  }, [isModalOpen]);

  useState(() => {
    event.on('event-showLoginModal', setIsModalOpen);
    event.on('event-showOtherClientStatus', setShowOtherClientStatus);
  });

  const location = useLocation();

  useMemo(() => {
    const token = getCookieToken();
    if (!token) {
      if (history.location.pathname === '/' || history.location.pathname === '/aminerandzhiyin') {
      } else {
        setIsModalOpen(true);
      }
    }
  }, [location]);

  const [showPageActionStatus, setShowPageActionStatus] = useState(false); // 显示长时间未操作文案

  useMemo(() => {
    if (isModalOpen) return;
    setShowPageActionStatus(false);
  }, [isModalOpen]);

  const setTokenLoadingRef = useRef(false);

  useEffect(() => {
    let fn1;
    customCookieEventListener(ACCESS_TOKEN, async ({ value }) => {
      let fn = async () => {
        if (value) {
          if (window.isBtnClick) {
            window.isBtnClick = false;
            return;
          }
          await initSet(value);
          props.onClose?.(getLocalZhiyinUser()); //
          setIsModalOpen(false);
        } else {
          props.onLoginShow?.(); // 弹框显示回调
          clearTimeout(autoRefreshInterval);
          clearTimeout(pageActionInterval);
          setIsModalOpen(true);
        }
      };
      if (document.hidden) {
        fn1 = fn;
      } else {
        fn1 = undefined;
        fn();
      }
    });
    let preUserInfo: any;
    watchPageVisibility(
      () => {
        const _userinfo = getLocalZhiyinUser();
        if (_userinfo) {
          preUserInfo = _userinfo;
        }
      },
      function () {
        if (preUserInfo) {
          const _userinfo: any = getLocalZhiyinUser();
          if (_userinfo) {
            if (_userinfo.userId !== preUserInfo.userId) {
              setIsModalOpen(false);
              setShowTabRefresh(true);
              preUserInfo = null;
              return;
            }
          }
        }
        if (fn1) {
          console.log('fn');
          fn1();
          fn1 = undefined;
        }
      },
    );
  }, []);

  useEffect(() => {
    customLocalStorgeEventListener('aminerOtherClientStatus', ({ value }) => {
      if (value) {
        setIsModalOpen(true);
        setShowOtherClientStatus(true);
        setTimeout(() => {
          delCookieToken();
        }, 700);
      }
    });
  }, []);

  // 初始化配置
  async function initSet(token?: string) {
    try {
      if (token) {
        await setTokenFn(); // 单点登录
        const userInfo = await getZhiyinUserInfo();
        if (!userInfo) return;
        onCloseLoginModal();
        actionListener(); // 监听自动过期
        props.autoLoginSuccess?.(userInfo); // 登录成功
      }
    } catch (error) {
      if (error.response?.data?.code === 200007) {
        const magicInfo = await magicGetFontMeApi([{ action: 'user.GetMe' }]);
        const userInfo = magicInfo?.data?.[0]?.items?.[0];
        if (userInfo) {
          onCloseLoginModal();
          setLocalZhiyinUser(userInfo);
          props.autoLoginSuccess?.(userInfo); // 登录成功
        }
      }
    }
  }

  // 登录成功
  async function onLoginSuccess(token, refresh_token) {
    // 登录成功 获取用户信息
    try {
      const res = await setTokenApi(token);
      if (res?.code === 200) {
        window.isBtnClick = true;
        setCookieTokens(token, refresh_token);
        setIsModalOpen(false);
        const userInfo = await getZhiyinUserInfo();
        await props.onLoginSuccess?.(userInfo);
      }
    } catch (error) {
      if (error.response?.data?.code === 200007) {
        window.isBtnClick = true;
        setIsModalOpen(false);
        showBindPhoneModal(true, { showAlert: true });
        setCookieTokens(token, refresh_token);
        const magicInfo = await magicGetFontMeApi([{ action: 'user.GetMe' }]);
        const userInfo = magicInfo?.data?.[0]?.items?.[0];
        if (userInfo) {
          setLocalZhiyinUser(userInfo);
          props.autoLoginSuccess?.(userInfo);
        }
      }
    }
  }

  // 长时间页面没有操作监听
  function actionListener() {
    clearTimeout(pageActionInterval);

    function go() {
      const currentTimeStamp = new Date().getTime(); // 当前时间戳

      // 获取上次操作的时间
      const preTimeStamp = getPageActionTimeCount(); // 获取多个页面共用

      if (preTimeStamp <= 0) {
        setPageActionTimeCount(Date.now());
        go();
        return;
      }

      // outTime 多长时间没有操作，单位秒
      const t = 72 * 3600 * 1000;

      if (currentTimeStamp - preTimeStamp > t) {
        // 长时间没有操作 退出登录
        setIsModalOpen(true);
        setShowPageActionStatus(true); // 显示文案
        onShowLoginModal();
        return;
      }

      pageActionInterval = setTimeout(() => {
        go();
      }, 1000);
    }

    //页面倒计时
    go();
  }

  function handleUserAction() {
    // 用户操作了页面
    const timeStamp = new Date().getTime(); // 当前时间戳
    setPageActionTimeCount(timeStamp); // 缓存多个页面共用
  }

  useEffect(() => {
    // 记录用户操作的时间
    const eventTypes = [
      'scroll',
      'keydown',
      'keydoup',
      'click',
      'mousedown',
      'mousemove',
      'mouseup',
      'touchstart',
      'touchend',
      'mousewheel',
    ];

    handleUserAction();

    const throttleTime = 1000; // 1000 毫秒（1秒）
    const throttledHandler = _.throttle(handleUserAction, throttleTime);

    for (const type of eventTypes) {
      document.body.addEventListener(type, throttledHandler);
    }

    return () => {
      for (const type of eventTypes) {
        document.body.removeEventListener(type, throttledHandler);
      }
    };
  }, []);

  // 获取知音用户
  async function getZhiyinUserInfo() {
    let token = getCookieToken();
    if (!token) return;
    // 获取用户信息 获取aminer用户信息
    const [res, magicInfo] = await Promise.all([
      getFontMeApi({}),
      magicGetFontMeApi([{ action: 'user.GetMe' }]),
    ]);
    // 处理当前用户 是否__vip,__notice 等
    const userInfo = await processNoticeData({
      ...magicInfo?.data?.[0]?.items?.[0],
      ...res.data,
    });
    if (userInfo) {
      setLocalZhiyinUser(userInfo);
      return userInfo;
    }
  }

  const isShowClose = props.onShowCloseIcon?.();

  const [activeKeyTab, setActiveKeyTab] = useState('1');

  return (
    <>
      {!!isModalOpen && (
        <Modal
          maskClosable={false}
          width={props?.width || 480}
          destroyOnClose={true}
          centered={true}
          closable={false}
          open={!!isModalOpen}
          wrapClassName={'loginModalWrap'}
          footer={null}
          title={
            <div className={'loginHeader'}>
              <div className="updPassBack" onClick={() => setCurrentAction('login')}>
                {currentAction == 'setPwd' && (
                  <>
                    <LeftOutlined className={'closeIcon'} />
                    返回
                  </>
                )}
              </div>

              {isShowClose && (
                <div
                  className={'closeIcon'}
                  onClick={() => {
                    setIsModalOpen(false);
                  }}
                >
                  <CloseOutlined />
                </div>
              )}
            </div>
          }
        >
          {/*长时间未操作*/}
          {showPageActionStatus && currentAction == 'login' ? (
            <AlertText text="由于长时间未操作，已自动退出登录，请重新登录" />
          ) : showOtherClientStatus && currentAction == 'login' ? (
            <AlertText text="帐号已在其他设备上登录，如果不是本人操作，请及时修改密码" />
          ) : null}

          {/*登录*/}
          {currentAction == 'login' && (
            <Login
              {...props}
              onLoginSuccess={onLoginSuccess}
              onClickPwd={(value: string) => setCurrentAction(value)}
              activeKeyTab={activeKeyTab}
              setActiveKeyTab={setActiveKeyTab}
              setTokenLoadingRef={setTokenLoadingRef}
            />
          )}
          {/*重置密码*/}
          {currentAction == 'setPwd' && (
            <SetPwd
              {...props}
              isUpdStatus={false}
              findBackPasswordSuccess={() => {
                setCurrentAction('login');
              }}
            />
          )}
        </Modal>
      )}

      {/* tab 页面刷新 */}
      <Modal
        width={406}
        open={showTabRefresh}
        className={'tabUserCode'}
        maskClosable={false}
        okText={'刷新'}
        closable={false}
        footer={null}
        title={
          <div>
            <ExclamationCircleFilled size={21} style={{ color: '#FF7D00', fontSize: 21 }} />
            <span className="codeTitle">登录账号变更</span>
          </div>
        }
      >
        <div className="codeContent">当前登录账号已变更，请刷新页面获取最新内容</div>
        <div className="codeBtn">
          <Button
            type="primary"
            onClick={() => {
              window.location.reload(); // 登录成功，强制刷新
            }}
          >
            刷新
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default LoginApp;
